import React from 'react';
import styled from 'styled-components';
import Text from '@/common/view/Text';
import Button from '@/common/view/button';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/main/controller/MainController';

const StyledPage = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.gray10};
`;
const ContentBox = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <StyledPage>
      <ContentBox>
        <Text typo="subtitle1">현재 페이지에 대한 접근 권한이 없습니다</Text>
        <Text typo="body1">관리자에게 권한을 요청하거나 다른 페이지를 이용해주세요</Text>
        <div
          style={{
            paddingTop: '24px',
          }}>
          <Button
            skin="primary"
            size="small"
            onClick={() => {
              navigate(PATH.MAIN, { replace: true });
            }}>
            홈으로 이동
          </Button>
        </div>
      </ContentBox>
    </StyledPage>
  );
};

export default UnauthorizedPage;
